import React from 'react';

import Icon from '../Icon/Icon';

const TncDataCollectionIcon = (props) => {
    return (
        <Icon width='64' height='64' fill='none' {...props}>
            <path
                d='M51.5152 13.2859C37.1574 7.53012 28.8723 7.61279 13.7021 13.2859C11.0928 34.1769 15.426 43.2328 32.2935 55.1955C50.6051 43.7813 53.3497 33.9338 51.5152 13.2859Z'
                fill='#393E44'
                stroke='#00D1D2'
                strokeWidth='2.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M24 30.5L31.107 37.6286L43 23'
                stroke='#FFFDFB'
                strokeWidth='2.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </Icon>
    );
};

export default TncDataCollectionIcon;
